import { STORAGE_KEYS } from '@/constants/storage'

export default goal => {
  localStorage.setItem(STORAGE_KEYS.goalTemplate, JSON.stringify(goal))
}
